import fetch from 'isomorphic-fetch';
import request from 'superagent';
import fileDownload from 'js-file-download';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import { mandatoryServerSide } from './mandatoryAttributes';

// https://tonyspiro.com/how-to-keep-session-data-after-fetch-post-with-express/#comment-2544007117

function getUrl(path) {
  if (path.startsWith('http') || ExecutionEnvironment.canUseDOM) {
    return path;
  }
  return process.env.WEBSITE_HOSTNAME ?
    `http://${process.env.WEBSITE_HOSTNAME}${path}` :
    `http://127.0.0.1:3000${path}`;
}

const HttpClient = {
  get: (path) => new Promise((resolve, reject) => {
    fetch(getUrl(path), { credentials: 'include' })
    .then(response => response.json())
    .then((data) => {
      resolve(data);
    });
  }),

  // get: (path, params = mandatoryServerSide(path)) => new Promise((resolve, reject) => {
  //   const headers = params ? params.headers : {accept: 'application/json'};
  //   request
  //     .get(getUrl(path))
  //     .set(headers)
  //     .end((err, res) => {
  //       if (err) {
  //         if (err.status === 404) {
  //           resolve(null);
  //         } else {
  //           reject(err);
  //         }
  //       } else {
  //         resolve(res.body);
  //       }
  //     });
  // }),


  postDownload: (path, dataObject) => new Promise((resolve, reject) => {
    fetch(getUrl(path), { 
      credentials: 'include', 
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: dataObject,
    })
    .then(response => {
      return response.blob()
    })
    .then((data) => {
      fileDownload(data, 'file2.pdf');
      resolve('ok');
    });
  }),

  postAsync: (path, dataObject) => new Promise((resolve, reject) => {
    fetch(getUrl(path), { 
      credentials: 'include', 
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      body: dataObject,
    })
    .then(response => {
      return response.json()
    })
    .then((data) => {
      resolve(data);
    });
  }),

  post: (path, dataObject) => new Promise((resolve, reject) => {
    request
      .post(getUrl(path))
      .accept('application/json')
      .send(dataObject || {})
      .end((err, res) => {
        if (err) {
          if (err.status === 409) {
            // resolve(null);
            reject(err);
          } else {
            reject(err);
          }
        } else {
          resolve(res.text);
        }
      });
  }),


  delete: (path, dataObject) => new Promise((resolve, reject) => {
    fetch(getUrl(path), { 
      credentials: 'include', 
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(dataObject),
    })
    .then(response => {
      if(!response.ok) {
        throw response
      }
      return response.json()
    })
    .then((data) => {
      resolve(data);
    })
    .catch(error => reject(error))
  }),

};

export default HttpClient;



// WEBPACK FOOTER //
// ./src/core/HttpClient.js